export default __webpack_public_path__ + "static/media/ic-close.12463ad8.svg";